export enum FINANCIAL_PUBLICATION {
  FULL_YEAR_RESULTS = 'full-year-results',
  GREEN_BOND = 'green-bond',
  HALF_RESULTS = 'half-results',
  INVESTOR_PRESENTATIONS = 'investor-presentations',
  REFERENCE_DOCUMENT = 'reference-document',
  RSE_REPORT = 'rse-report',
  URD = 'urd',
  ENTERPRISE_GOVERNMENT_REPORT = 'rapport-gouvernement-entrprise',
  VOTING_RIGHT_NB_ACTIONS = 'droits-vote-nb-actions',
}
